import React, { memo, useCallback } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import useColors from 'hooks/useColors';
import { InfoModal } from 'features/invest/components/InfoModal';
import Text from './Text';
import Spacer from './Spacer';
import { hitSlopS } from './values';
import IconTooltip from './icons/IconTooltip';
import ToolTip from './ToolTip';
import { isWeb } from '../constants';
const CardRowTitleWithToolTip = ({ bold, title, toolTipTitle, toolTipDescription, }) => {
    const colors = useColors();
    const onPress = useCallback(() => {
        InfoModal.show(toolTipTitle, toolTipDescription);
    }, [toolTipTitle, toolTipDescription]);
    return (<View style={styles.tradingChargeTitleContainer}>
      <Text {...(bold ? { 'Text-14': true } : { 'TextThin-14': true })} Gray>
        {title}
      </Text>
      <Spacer w={4}/>
      <View>
        <Spacer h={3}/>
        {isWeb ? (
        // On web the explanation shows on hover rather than in a modal
        <ToolTip small colorKey="secondary" title={toolTipTitle} subtitle={toolTipDescription}/>) : (<TouchableOpacity onPress={onPress} hitSlop={hitSlopS}>
            <IconTooltip width={16} height={16} color={colors.text.secondary}/>
          </TouchableOpacity>)}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    tradingChargeTitleContainer: {
        flexDirection: 'row',
    },
});
export default memo(CardRowTitleWithToolTip);
